import { useSubmitGuard } from "@/hooks/useSubmitGuard";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	FormBuilder,
} from "@k3-tech/react-kit";

export interface CategoryFormValues {
	salesChannelCategoryName: string;
	displayOrder: number;
	isActive: boolean;
	isInMenu: boolean;
}

export interface SalesChannelCategoryFormDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	mode: "create" | "edit";
	defaultValues?: Partial<CategoryFormValues>;
	onSubmit: (values: CategoryFormValues) => unknown;
}

export function SalesChannelCategoryFormDialog({
	open,
	onOpenChange,
	mode,
	defaultValues,
	onSubmit,
}: SalesChannelCategoryFormDialogProps) {
	const { isSubmitting, guardedSubmit } = useSubmitGuard(onSubmit);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-md">
				<DialogHeader>
					<DialogTitle>
						{mode === "create" ? "Add Category" : "Edit Category"}
					</DialogTitle>
				</DialogHeader>
				<FormBuilder<CategoryFormValues>
					onSubmit={guardedSubmit}
					isSubmitting={isSubmitting}
					onCancel={() => onOpenChange(false)}
					defaultValues={defaultValues}
					actionsClassName="justify-end"
					showActionsSeparator={false}
					sections={[
						{
							layout: "grid",
							grid: { cols: 1, gap: "gap-4" },
							fields: [
								{
									name: "salesChannelCategoryName",
									label: "Category Name",
									type: "text",
									required: true,
									defaultValue: "",
								},
								{
									name: "displayOrder",
									label: "Display Order",
									type: "number",
									required: true,
									defaultValue: 1,
								},
							],
						},
						{
							layout: "flex",
							fields: [
								{
									name: "isInMenu",
									label: "Show in Menu",
									type: "switch",
									defaultValue: true,
								},
								{
									name: "isActive",
									label: "Active",
									type: "switch",
									defaultValue: true,
								},
							],
						},
					]}
					submitLabel={mode === "create" ? "Add" : "Save"}
				/>
			</DialogContent>
		</Dialog>
	);
}
